"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amazonFieldNameToIssueGroup = exports.KnownAmazonFieldNames = exports.IssueGroups = void 0;
exports.IssueGroups = [
    "Title",
    "Image",
    "Attributes",
    "Description",
    "Other",
];
exports.KnownAmazonFieldNames = [
    "abpa_partslink_number",
    "brand",
    "brand_name",
    "color",
    "department",
    "fabric_type",
    "footwear_size",
    "image",
    "item_dimensions",
    "item_length_width",
    "item_name",
    "metal_type",
    "product_description",
    "size",
    "subject_character",
    "unit_count",
    "special_feature",
    "unknown",
];
const amazonFieldNameToIssueGroup = (fieldName) => {
    const knownFieldName = exports.KnownAmazonFieldNames.find((fn) => fn === fieldName);
    if (knownFieldName) {
        switch (knownFieldName) {
            case "abpa_partslink_number":
            case "brand":
            case "brand_name":
            case "color":
            case "department":
            case "fabric_type":
            case "footwear_size":
            case "item_dimensions":
            case "item_length_width":
            case "metal_type":
            case "size":
            case "subject_character":
            case "unit_count":
                return "Attributes";
            case "product_description":
                return "Description";
            case "image":
                return "Image";
            case "item_name":
                return "Title";
            case "unknown":
                return "Other";
            default:
                return "Other";
        }
    }
    return "Other";
};
exports.amazonFieldNameToIssueGroup = amazonFieldNameToIssueGroup;
//# sourceMappingURL=suppressedProducts.js.map